import React from 'react'
// const iconv = require('iconv-lite')
// import rNFetchBlob from 'react-native-fetch-blob'
// import XLSX from 'xlsx'

// const convBig5toUTF8 = iconv.decodeStream('cp950')

const selectOptions = {
  productsB: 'B類商品資料',
}

class ImportCsv extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      content: '',
      notification: '',
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
  }
  uploadFile () {
    // console.log('lastModified:', this.fileInput.files[0].slice(1, 2))
    const filename = this.fileInput.files[0].name
    console.log('upload', this.fileInput.files[0].name)
    const filenameSplit = filename.split('.')
    const filetype = filenameSplit[filenameSplit.length - 1]
    this.setState({
      notification: '正在進行匯入，請稍候...',
    })

    const parseCSV = () => {
      console.log('run parseCSV')
      const fileReader = new FileReader()
      fileReader.onload = () => {
        console.log('run onload')
        const result = fileReader.result
        console.log(result)
        // const MIME_TYPE = 'application/vnd.ms-excel'
        const file = new File([result], filename, { type: 'application/vnd.ms-excel' })
        console.log(file)
        fetch(
          `api/stream/${this.select.value}?type=${filetype}`,
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/octet-stream',
            },
            body: file,
          },
         )
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then((response) => {
          // data array in response
          console.log('未匯入資料:', response.data)
          let outputContent = ''
          outputContent += `完成匯入! 資料筆數: ${response.data.length - 1}`
          outputContent += `${'\n'}以下資料未匯入:`
          let unimportedCount = 0
          for (let i = 1; i < response.data.length; i++) {
            if (response.data[i] !== null) {
              outputContent += `${'\n'}${response.data[i]}`
              unimportedCount++
            }
          }
          outputContent += `${'\n'}未匯入資料數: ${unimportedCount}`

          this.setState({
            content: outputContent,
          })
          console.log('import done')
          this.setState({
            notification: '',
          })
        }).catch((response) => {
          console.log('upload error', response)
        })
        // return file
      }
      fileReader.readAsText(this.fileInput.files[0], 'big5')
      console.log(this.fileInput.files[0])
    }
    if (this.encoding.value === 'CP950' && filetype === 'csv') parseCSV()
    if (this.encoding.value === 'UTF-8' || filetype !== 'csv') {
      fetch(
      `api/stream/${this.select.value}?type=${filetype}`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/octet-stream',
          },
          body: this.fileInput.files[0],
        },
     )
    .then((response) => (response.ok ? response.json() : Promise.reject(response)))
    .then((response) => {
      // data array in response
      console.log('未匯入資料:', response.data)
      let outputContent = ''
      outputContent += `完成匯入! 資料筆數: ${response.data.length - 1}`
      outputContent += `${'\n'}以下資料未匯入:`
      let unimportedCount = 0
      for (let i = 1; i < response.data.length; i++) {
        if (response.data[i] !== null) {
          outputContent += `${'\n'}${response.data[i]}`
          unimportedCount++
        }
      }
      outputContent += `${'\n'}未匯入資料數: ${unimportedCount}`

      this.setState({
        content: outputContent,
      })
      console.log('import done')
      this.setState({
        notification: '',
      })
    }).catch((response) => {
      console.log('upload error', response)
    })
    }
  }
  handleSelect () {
    console.log('select', this.select.value)
    if (this.select.value) {
      this.setState({
        notification: `已選擇${selectOptions[this.select.value]}，請選取匯入檔案`,
      })
    } else {
      this.setState({
        notification: '請下拉選擇匯入種類',
      })
    }
  }
  render () {
    return (
      <div>
        <select
          ref={ref => (this.select = ref)}
          onChange={this.handleSelect}
        >
          <option value=""> ---- 請選擇匯入資料 ---- </option>
          <option value="productsB">B類商品資料</option>
        </select>
        <select
          ref={ref => (this.encoding = ref)}
        >
          <option value="CP950">使用預設編碼(CP950)</option>
          <option value="UTF-8">使用UTF-8編碼</option>
        </select>
        <br />
        <input
          ref={ref => (this.fileInput = ref)}
          type="file"
          id="upload_input"
          onChange={this.uploadFile}
        />
        <br />
        <text style={{ whiteSpace: 'pre-line' }}>{this.state.notification}</text>
        <text style={{ whiteSpace: 'pre-line' }}>{this.state.content}</text>
      </div>
    )
  }
}

export default ImportCsv



// WEBPACK FOOTER //
// ./src/components/ImportProducts/ImportProducts.jsx